module.exports = __webpack_public_path__ + "img/fraude_seven.16f39128.png";